import React, { useEffect, useState, FormEventHandler } from "react";
import { Form, Button } from "react-bootstrap";
import { TimeBoxProps, TimeTypes } from "./TimeBox.props";
import { ReactComponent as DonNoghte } from "assets/images/do-noghte.svg";
import useInterval from "hooks/UseInterval";
import "./style.scss";

const TimeBox = React.memo<TimeBoxProps>(
    ({
        getTimeChange,
        isTimeSaved,
        title,
        notifText,
        isUpdate,
        defaultTime,
    }) => {
        const [currentTime, setCurrentTime] = useState<TimeTypes>();

        useEffect(() => {
            if (!isUpdate) {
                getTime();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        useEffect(() => {
            if (isUpdate && defaultTime) {
                const hours = +defaultTime.split(":")[0];
                const minutes = +defaultTime.split(":")[1];
                setCurrentTime({
                    hour: hours < 10 ? `0${hours}` : `${hours}`,
                    minute: minutes < 10 ? `0${minutes}` : `${minutes}`,
                    second: "00",
                });
            }
        }, [isUpdate, defaultTime]);

        useInterval(() => {
            if (!isUpdate) {
                getTime();
            }
        }, 60000);

        const getTime = () => {
            const date = new Date();
            const hours = +date.getHours();
            const minutes = +date.getMinutes();

            setCurrentTime({
                hour: hours < 10 ? `0${hours}` : `${hours}`,
                minute: minutes < 10 ? `0${minutes}` : `${minutes}`,
                second: "00",
            });
        };

        const handleSubmit: FormEventHandler = (e) => {
            e.preventDefault();
            getTimeChange(currentTime);
        };

        const onChange = (name: string, value: string | number) => {
            const numberValue = Number(value);
            if (currentTime) {
                setCurrentTime({
                    ...currentTime,
                    [name]: numberValue < 10 ? "0" + numberValue : numberValue,
                });
            }
        };

        return (
            <div className="time-box">
                <span className="text">{title} :</span>
                <Form
                    className="time-box-form-container"
                    onSubmit={handleSubmit}
                >
                    <div className="inputs-wrapper">
                        <Form.Control
                            type="number"
                            name="hour"
                            min="0"
                            max="23"
                            className="time-item"
                            disabled={isTimeSaved}
                            defaultValue={currentTime?.hour}
                            onChange={(e) => onChange("hour", e.target.value)}
                        />
                        <DonNoghte className="dot-icon" />
                        <Form.Control
                            type="number"
                            name="minute"
                            min="0"
                            max="59"
                            className="time-item"
                            disabled={isTimeSaved}
                            defaultValue={currentTime?.minute}
                            onChange={(e) => onChange("minute", e.target.value)}
                        />
                    </div>
                    <Button
                        className={`form-submit-btn float-right ${
                            isTimeSaved ? "timeSaved" : ""
                        }`}
                        variant="secondary"
                        data-testid="TimeBox__submitButton"
                        type="submit"
                    >
                        {`${isTimeSaved ? "ویرایش" : "ذخیره"}`}
                    </Button>
                </Form>
                <span className="notif-text">{notifText}</span>
            </div>
        );
    }
);

export default TimeBox;
